// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "controllers/application"
import ChatController from "./chat_controller"
application.register("chat", ChatController)

// import { eagerLoadControllersFrom } from "@hotwired/stimulus-loading" DAVID: I commented this out bc I changed to Webpack and there is no such library
// eagerLoadControllersFrom("controllers", application)